import styled from "styled-components";

export const DataIndexTableColumnModalContainer = styled.div`
    .flex-box{
        display: flex;
        align-items: center;
        gap: 10px;
    }
    .flex-box h4, .flex-box h5{
        margin-bottom: 0px;
    }
    .flex-box p{
        margin-top: 5px;
        margin-bottom: 5px;
        color: #fff;
    }
    .lasData_label_text {
        background-color: #686565;
        padding: 8px;
        font-weight: 700;
    }
    .flex-box label{
        color: #fff;
    }
    .ant-modal-title{
        font-size: 20px !important;
        color: #8Aa1c4 !important;
    }
    .ant-modal-header{
        margin-bottom: 15px;
    }
    .table_title{
        font-size: 18px;
        margin: 10px 0px;
        color: #36BDBE !important;
    }
    .inputData_table th{
        border-color: #f5f5f54d;
        background-color: #33383C;
        color: #fff;
        font-size: 15px;
        font-weight: bold;
        border: none;
        border-right: 1px solid #f5f5f54d;
        border-bottom: 1px solid #f5f5f54d;
    }
    .lasData_table .lasData_label{
        font-weight: 600;
        color: #36BDBE !important;
    }
    .lasData_table td{
        padding: 5px 15px 5px 0px;
        color: #fff;
    }
    .inputData_table td{
        border-color: #f5f5f54d;
        font-size: 12px;
        border: none;
        border-right: 1px solid #f5f5f54d;
        padding: 8px 16px;
        color: #fff;
        border-bottom: 1px solid #f5f5f54d;
    }
    .process_modal_table{
        background-color: #33383C !important;
        border: 1px solid #f5f5f54d !important;
        box-shadow: none;
    }
    .lasData_map{
        border: 1px solid lightgray;
        height: 200px;
        width: 200px;
    }
    .inlineBox{
        display: inline;
        margin-top: 10px;
    }
    .inlineBox .ant-checkbox-group{
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        align-items: center;
    }
    .inlineBox label{
        margin-right: 12px;
        margin-bottom: 5px;
        color: #fff;
    }
    .visible_classes_block{
        margin-top: 17px;
    }
    .data-export{
        background-color: #007a7a;
        color: #ffffff; 
        font-size: 12px !important;
        border: 0px;
    }
    .data-export:disabled{
        background-color: #d9d9d9;
        color: #000000;
    }
    .data-export:hover{
        background-color: #cbd4d5 !important;
        color: #526e74 !important;
        border-color: #cbd4d5 !important;
    }
    .align-right{
        text-align: right;
    }
    .option-box{
        margin: 12px 0px 8px 0px;
    }
    .option_dropdown .ant-select-selection-placeholder{
        padding-inline-end: 25px !important;
        color:#000;
    }
    .option_dropdown{
        margin-left: 10px;
    }
    .option_dropdown svg{
        width: 16px !important;
        height: 16px !important;
    }
    .modal-top-header{
        border-top: 1px solid lightgray;
        border-bottom: 0px;
        padding-top: 15px;
    }
    .modal-footer{
        border-top: 1px solid lightgray;
    }

    .anticon svg {
        display: inline-block;
        color: #36BDBE !important;
    }

        
    .checkbox_table .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #007a7a;
    border-color: #007a7a;
    } 

    .checkbox_table .ant-checkbox-indeterminate .ant-checkbox-inner:after {
    background-color: #007a7a;
    }

    .checkbox_table .ant-checkbox-indeterminate .ant-checkbox-inner {
    background-color: #ffffff;
    border-color: #d9d9d9;
    }

    .checkbox_table.ant-checkbox-wrapper-checked:not(.ant-checkbox-wrapper-disabled):hover .ant-checkbox-inner, .checkbox_table.ant-checkbox-checked:not(.ant-checkbox-disabled):hover .ant-checkbox-inner {
    background-color: #007a7a !important;
    border-color: transparent;
    }

    .checkbox_table.ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover .ant-checkbox-inner, .checkbox_table.ant-checkbox:not(.ant-checkbox-disabled):hover .ant-checkbox-inner {
    border-color: #007a7a !important;
    }

    .checkbox_table.ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover .ant-checkbox-checked:not(.ant-checkbox-disabled) .ant-checkbox-inner {
    background-color: #007a7a !important;
    border-color: transparent;
    }

    .checkbox_table.ant-checkbox-wrapper-checked:not(.ant-checkbox-wrapper-disabled):hover .ant-checkbox-inner, .checkbox_table.ant-checkbox-checked:not(.ant-checkbox-disabled):hover .ant-checkbox-inner {
    background-color: #007a7a !important;
    border-color: transparent;
    }

    .checkbox_table .ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover .ant-checkbox-checked:not(.ant-checkbox-disabled) .ant-checkbox-inner {
    background-color: #007a7a !important;
    border-color: transparent;
    }

    @media only screen and (max-width: 767px) {
        .inlineBox .ant-checkbox-group{
            grid-template-columns: repeat(2, 1fr);
        }
    }
`;

export const DataIndexTableColumnMenuModalContainer = styled.div`
    .flex-box{
        display: flex;
        align-items: center;
        gap: 10px;
    }
    .flex-box h4, .flex-box h5{
        margin-bottom: 0px;
    }
    .flex-box p{
        margin-top: 5px;
        margin-bottom: 5px;
    }
    .ant-modal-title{
        font-size: 20px !important;
        color: #8Aa1c4 !important;
    }
    .ant-modal-header{
        margin-bottom: 15px;
    }
    .table_title{
        font-size: 16px;
        margin: 10px 0px;
        color: #8Aa1c4;
    }
    .inputData_table{
        margin-top: 20px;
    }
    .inputData_table th{
        border-color: #f5f5f54d;
        background-color: #33383C;
        color: #fff;
        font-size: 16px;
        font-weight: bold;
        padding: 10px 10px;
        border-right: 1px solid #f5f5f54d;
    }
    .lasData_table .lasData_label{
        font-weight: 600;
    }
    .lasData_table td{
        padding: 5px 15px 5px 0px;
    }
    .inputData_table td{
        border-color: #f5f5f54d;
        font-size: 12px;
        padding: 12px 10px;
        border-right: 1px solid #f5f5f54d;
        color: #fff;
    }
    .lasData_map{
        border: 1px solid lightgray;
        height: 200px;
        width: 200px;
    }
    .inlineBox{
        display: inline;
        margin-top: 10px;
    }
    .inlineBox .ant-checkbox-group{
        display: inline;
    }
    .inlineBox label{
        margin-right: 12px;
        margin-bottom: 5px;
    }
    .visible_classes_block{
        margin-top: 10px;
    }
    .export-dialog-open{
        background-color: #007a7a;
        color: #ffffff; 
        font-size: 12px !important;
        border: 0px;
    }
    .export-dialog-open:hover{
        background-color: #cbd4d5 !important;
        color: #526e74 !important;
        border-color: #cbd4d5 !important;
    }
    .export-dialog-open:disabled{
        background-color: #cccccc;
    }
    .export-dialog-open:disabled:hover{
        background-color: #cccccc !important;
        color: #ffffff !important;
        border-color: #cccccc !important;
    }
    .align-right{
        text-align: right;
    }
    .option-box{
        margin: 12px 0px 8px 0px;
    }
    .option_dropdown .ant-select-selection-placeholder{
        padding-inline-end: 25px !important;
    }
    .option_dropdown{
        margin-left: 10px;
    }
    .option_dropdown svg{
        width: 16px !important;
        height: 16px !important;
    }
    .modal-top-header{
        border-top: 1px solid lightgray;
        border-bottom: 0px;
        padding-top: 15px;
    }
    .modal-footer{
        border-top: 1px solid lightgray;
    }
    .help_icon_center{
        text-align: center;
    }
    .help_icon{
        font-size: 20px;
        color: #fff;
    }
    .process_modal .ant-modal-content{
        background-color: #33383C !important;
        border: 1px solid #f5f5f54d !important;
    }
   .ant-modal-header{ 
        background: #33383C !important;
        color: #36BDBE !important;
    }
     .anticon svg {
        display: inline-block;
        color: #36BDBE !important;
    }
    .process_modal_table{
        background-color: #33383C !important;
        border: 1px solid #f5f5f54d !important;
        box-shadow: none;
    }
    .processing_data_block{
        color: #ffffff;
        gap: 15px;
        display: flex;
        align-items: center;
        padding-top: 10px;
    }
    .processing_data_block label{
        margin-bottom: 0px;
    }
`;
    
export const DataIndexTableSearchableContainer = styled.div`
      .inputData_table_searchable .css-1tbggly {
        background-color: #33383c !important;
        border: 1px solid #f5f5f54d !important;
        min-height: 4.5rem;
      }
      .inputData_table_searchable
        .css-78trlr-MuiButtonBase-root-MuiIconButton-root {
        color: #fff;
      }
      .inputData_table_searchable tbody tr.MuiTableRow-root {
        background-color: #33383c !important;
      }
      .inputData_table_searchable .css-10gei56 {
        background-color: #33383c !important;
        min-height: 4.5rem;
      }
      .inputData_table_searchable {
        border: 1px solid #f5f5f54d !important;
        border-radius: 8px;
      }
      .inputData_table_searchable .css-1atu56z-MuiPaper-root {
        color: #fff;
      }
      .inputData_table_searchable .MuiTablePagination-root .MuiFormLabel-root.MuiInputLabel-root.MuiInputLabel-animated.MuiFormLabel-colorPrimary.MuiInputLabel-root.MuiInputLabel-animated {
        color: #fff;
        font-size: 15px;
      }
      .inputData_table_searchable
        .css-1mmm5cp-MuiInputBase-root-MuiInput-root-MuiSelect-root {
        color: #fff;
        font-size: 15px;
      }
      .inputData_table_searchable .css-pqjvzy-MuiSvgIcon-root-MuiSelect-icon {
        color: #fff !important;
        font-size: 15px;
      }
      .inputData_table_searchable
        .css-1pe4mpk-MuiButtonBase-root-MuiIconButton-root.Mui-disabled {
        background-color: transparent;
        color: #fff;
      }
      .inputData_table_searchable
        .css-1v8abvc-MuiInputBase-root-MuiOutlinedInput-root {
        color: #fff;
      }
      .inputData_table_searchable
        .MuiCollapse-wrapper.MuiCollapse-horizontal.css-18w3a48-MuiCollapse-wrapper {
        border: 1px solid #f5f5f54d !important;
        display: block !important;
        border-radius: 5px;
      }
      .inputData_table_searchable .MuiTableCell-head svg[data-testid="SyncAltIcon"] {
        color: #fff !important;
      }
      .inputData_table_searchable
        .Mui-TableHeadCell-Content-Actions.MuiBox-root.css-epvm6 {
        display: none !important;
      }
      // .inputData_table_searchable .css-i4bv87-MuiSvgIcon-root {
      //   font-size: 20px;
      // }
      .inputData_table_searchable .css-8k4lth {
        padding: 8px;
      }
      // .inputData_table_searchable .css-1f2oslk-MuiTypography-root {
      //     font-size: 15px;
      //   }
      .inputData_table_searchable
        .MuiSvgIcon-root[data-testid="CloseIcon"]  {
        font-size: 20px;
      }
      .inputData_table_searchable
        .MuiIconButton-root[aria-label="Clear search"] {
        color: rgb(196 192 192 / 54%);
      }
      .inputData_table_searchable
        .MuiIconButton-root[aria-label="Toggle full screen"] {
        display: none;
      }
      .inputData_table_searchable .MuiIconButton-root[aria-label="Toggle density"] {
        display: none;
      }
      .inputData_table_searchable
        .MuiIconButton-root[aria-label="Show/Hide columns"] {
        display: none;
      }
      .inputData_table_searchable
        .MuiIconButton-root[aria-label="Show/Hide filters"] {
        display: none;
      }
      .inputData_table_searchable .MuiTableSortLabel-icon {
        display: none !important;
      }
      .inputData_table_searchable .css-nhjqqh-MuiTableContainer-root {
        max-height: 600px;
      }
      .inputData_table_searchable
        .MuiCollapse-root.MuiCollapse-horizontal.MuiCollapse-entered.css-1d98dbz-MuiCollapse-root {
        display: block !important;
      }
      .inputData_table_searchable
        .css-12yjm75-MuiInputBase-input-MuiOutlinedInput-input::placeholder {
        color: #fff !important;
      }
      .inputData_table_searchable {
        margin-top: 20px;
      }
      .inputData_table_searchable th {
        border-color: #f5f5f54d;
        background-color: #33383ccc;
        color: #fff;
        font-size: 16px;
        font-weight: bold;
        padding: 10px 10px;
        border-right: 1px solid #f5f5f54d;
      }
      .inputData_table_searchable td {
        border-color: #f5f5f54d;
        font-size: 12px;
        padding: 12px 10px;
        border-right: 1px solid #f5f5f54d;
        color: #fff;
      }
    
      .info-icon-container {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: #fff;
        cursor: pointer;
    }
    
    .info-icon-container span {
        color: #000;
    }
    .inputData_table_searchable td:last-child span{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .inputData_table_searchable td:first-child{
        text-align:center;
    }
    .inputData_table_searchable .css-zrlv9q , .inputData_table_searchable .css-wsew38{
        justify-content: center;
    }
    .inputData_table_searchable .css-14vyde3-MuiCollapse-wrapperInner{
        width:450px;
    }
    .inputData_table_searchable .css-11sh9fj-MuiFormControl-root-MuiTextField-root ,.inputData_table_searchable  .css-1u3bzj6-MuiFormControl-root-MuiTextField-root {
        width:450px;
    }
    .inputData_table_searchable .css-euw4nl-MuiTableRow-root{
        background-color: #33383c !important;
    }
    .inputData_table_searchable .css-1ezkbdg-MuiButtonBase-root-MuiRadio-root{
        color: #fff !important;
    }
    .inputData_table_searchable .css-1ezkbdg-MuiButtonBase-root-MuiRadio-root.Mui-checked {
        color: #fff !important;
    }
    .inputData_table_searchable .css-1yq237c-MuiTableRow-root.Mui-selected {
        background-color: rgb(0 122 122) !important;
    }
    .inputData_table_searchable  .css-1yq237c-MuiTableRow-root td:after{
        background-color: transparent;
    }
    .inputData_table_searchable .selected-row {
        background-color: #e6f7ff; // Light blue as an example
    }
    .dataIndex_table button[area-label="Clear search"] {
        color: #ffffff;
    }
    .dataIndex_table button.Mui-disabled[area-label="Clear search"]{
        color: rgb(196 192 192 / 54%);
    }
    .inputData_table_searchable .MuiTablePagination-root button.Mui-disabled[aria-label="Go to first page"],
    .inputData_table_searchable .MuiTablePagination-root button.Mui-disabled[aria-label="Go to previous page"],
    .inputData_table_searchable .MuiTablePagination-root button.Mui-disabled[aria-label="Go to next page"],
    .inputData_table_searchable .MuiTablePagination-root button.Mui-disabled[aria-label="Go to last page"] {
        color: rgba(255, 255, 255, 0.2) !important;
        border-radius: 6px;
        padding: 3px 3px;
    }

    .inputData_table_searchable .MuiTablePagination-root button[aria-label="Go to first page"],
    .inputData_table_searchable .MuiTablePagination-root button[aria-label="Go to previous page"],
    .inputData_table_searchable .MuiTablePagination-root button[aria-label="Go to next page"],
    .inputData_table_searchable .MuiTablePagination-root button[aria-label="Go to last page"] {
        color: #36BDBE !important;
        border-radius: 6px;
        padding: 3px 3px;
    }

    .inputData_table_searchable .MuiTablePagination-root button[aria-label="Go to first page"] svg,
    .inputData_table_searchable .MuiTablePagination-root button[aria-label="Go to previous page"] svg,
    .inputData_table_searchable .MuiTablePagination-root button[aria-label="Go to next page"] svg,
    .inputData_table_searchable .MuiTablePagination-root button[aria-label="Go to last page"] svg {
        font-size: 27px !important;
    }
    .inputData_table_searchable .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation2 .MuiTablePagination-root .MuiTypography-root.MuiTypography-body2.MuiTypography-alignCenter{
        font-size: 14px;
        color: #ffffff !important;
    }
    .inputData_table_searchable .MuiTablePagination-root .MuiInputBase-root.MuiInput-root.MuiInputBase-colorPrimary{
        color: #36BDBE !important;
        font-size: 14px;
    }
    .inputData_table_searchable .MuiTablePagination-root .MuiInputBase-root.MuiInput-root.MuiInputBase-colorPrimary svg{
        color: rgb(54, 189, 190) !important;
        font-size: 22px;
    }
    .inputData_table_searchable .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation2 .MuiTablePagination-root .MuiTypography-root.MuiTypography-body2.MuiTypography-alignCenter{
        font-size: 14px;
    }
    .inputData_table_searchable .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-formControl.MuiInputBase-sizeSmall.MuiInputBase-adornedStart.MuiInputBase-adornedEnd {
        color: rgb(255, 255, 255);
        padding: 0px 10px;
        background: rgba(255, 255, 255, 0.24);
    }
    .inputData_table_searchable .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-formControl.MuiInputBase-sizeSmall.MuiInputBase-adornedStart.MuiInputBase-adornedEnd input {
        padding: 3px 0px !important;
        font-size: 14px !important;
        color: rgb(255, 255, 255) !important;
    }
    .inputData_table_searchable .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-formControl.MuiInputBase-sizeSmall.MuiInputBase-adornedStart.MuiInputBase-adornedEnd fieldset {
        border: none !important;
    }
    .inputData_table_searchable svg[data-testid="SearchIcon"] {
        font-size: 20px;
    }
    .inputData_table_searchable .MuiFormControl-root.MuiTextField-root
        width: 250px;
    }
    @media only screen and (max-width: 600px) {
        .inputData_table_searchable .css-14vyde3-MuiCollapse-wrapperInner {
            width: 150px; 
        }
    
        .inputData_table_searchable .css-11sh9fj-MuiFormControl-root-MuiTextField-root, .inputData_table_searchable .css-1u3bzj6-MuiFormControl-root-MuiTextField-root {
            width: 150px;
        }
    }
`;